<template>
    <div>
        <div class="internet-container">
            <div v-if="data.type === 'success' && data.isError === true " @click="closeBtn" class="internet-active">
                <div class="clop">
                    <img src="/image/good_internet.png">
                </div>
                <div class="det">
                    <h1>Oh Cool</h1>
                    <p>
                        {{data.message}}
                    </p>
                </div>
            </div>

            <div v-if="data.type === 'error' && data.isError === true " @click="closeBtn" class="internet-inactive">
                <div class="clop">
                    <img src="/image/no_internet.png">
                </div>
                <div class="det">
                    <h1>Oh Crap</h1>
                    <p>
                        {{data.message}}
                    </p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "Internet",
        props: {
            data: Object
        },
        mounted() {
            // setTimeout(()=>{
            //     $(".internet-container").fadeOut();
            // }, 2000);
        },
        methods: {
            closeBtn(e) {
                this.data.isError = false;
            }
        }
    }
</script>

<style scoped>
.internet-container {
    position: fixed;
    bottom: 20px;
    width: 400px;
    padding: 10px;
    left: 20px;
    z-index: 5;
}
.internet-active {
    background-color: white;
    height: 100px;
    border-radius: 5px;
    box-shadow: 0 10px 20px rgba(0, 229, 107, 0.1);
    border: solid 1px #00E56B;
}
.internet-inactive {
    background-color: white;
    height: 100px;
    border-radius: 5px;
    box-shadow: 0 10px 20px rgba(223, 11, 9, 0.1);
    border: solid 1px #df0b09;
}
.internet-container .clop {
    width: 120px;
    height: 100%;
    float: left;
}
.internet-container .clop img {
    width: 100%;
    height: 100%;
}
.internet-container .det {
    float: left;
    width: 230px;
    height: 100%;
    padding: 10px 0;
}
.internet-container .det h1 {
    margin: 0;
    font-size: 20px;
    font-weight: bold;
}
.internet-container .det p {
    margin: 0;
    font-size: 13px;
}
</style>
